<template>
  <div>
    <v-dialog
      v-model="showHelpDetailDialog"
      width="600px"
      persistent
    >
      <v-card>
        <div
          v-if="post"
          class="px-4 py-3 title"
        >
          {{ post.title }}
        </div>
        <v-divider />
        <v-card-text v-if="post">
          <HtmlViwer
            :content="post.content"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-4">
          <v-btn
            flat
            @click="grantAgreement(false)"
          >
            關閉
          </v-btn>
          <v-spacer />
          <v-btn
            dark
            color="green darken-1"
            @click="grantAgreement(true)"
          >
            同意
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      postId: '',
      showHelpDetailDialog: false,
      neverShow: false,

      post: null,

      cb: null,
    }
  },
  watch: {
    neverShow () {
      if (this.showHelpDetailDialog) {
        if (this.neverShow) {
          localStorage.setItem(`closeHelp${this.postId}`, '1')
        } else {
          localStorage.removeItem(`closeHelp${this.postId}`)
        }
      }
    },
  },
  methods: {
    async open (id) {
      if (localStorage.getItem(`closeHelp${id}`)) {
        return Promise.resolve(true)
      }

      this.showHelpDetailDialog = true
      try {
        this.loading = true
        this.postId = id
        const res = await this.$store.dispatch('post/viewPage', {
          poidSlug: id,
        })
        if (!res.data.error) {
          this.post = res.data.model
        }
        this.neverShow = false
      } finally {
        this.loading = false
      }
      return new Promise((resolve, reject) => {
        this.cb = resolve
      })
    },
    grantAgreement (grant = true) {
      if (grant) {
        localStorage.setItem(`closeHelp${this.postId}`, '1')
      }
      this.showHelpDetailDialog = false
      this.cb(grant)
    },
  },
}
</script>
